/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { skillEfficacyGetSettings } from "../funcs/skillEfficacyGetSettings.js";
import { skillEfficacyQueryInsights } from "../funcs/skillEfficacyQueryInsights.js";
import { skillEfficacyUpsertSettings } from "../funcs/skillEfficacyUpsertSettings.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { SkillEfficacySettings } from "../models/components/skillefficacysettings.js";
import {
  GetSkillEfficacySettingsRequest,
  GetSkillEfficacySettingsSecurity,
} from "../models/operations/getskillefficacysettings.js";
import {
  QuerySkillEfficacyInsightsRequest,
  QuerySkillEfficacyInsightsResponse,
  QuerySkillEfficacyInsightsSecurity,
} from "../models/operations/queryskillefficacyinsights.js";
import {
  UpsertSkillEfficacySettingsRequest,
  UpsertSkillEfficacySettingsSecurity,
} from "../models/operations/upsertskillefficacysettings.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class SkillEfficacy extends ClientSDK {
  /**
   * getSettings skillEfficacy
   *
   * @remarks
   * Get effective organization-wide skill efficacy sampling settings.
   */
  async getSettings(
    request?: GetSkillEfficacySettingsRequest | undefined,
    security?: GetSkillEfficacySettingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SkillEfficacySettings> {
    return unwrapAsync(skillEfficacyGetSettings(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * queryInsights skillEfficacy
   *
   * @remarks
   * Query activation-time skill efficacy, estimated savings, attributed session cost, and optional scored-session detail for the current project. Scores are sampled and costs fan out to every activated version.
   */
  async queryInsights(
    request?: QuerySkillEfficacyInsightsRequest | undefined,
    security?: QuerySkillEfficacyInsightsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<QuerySkillEfficacyInsightsResponse, { cursor: string }>
  > {
    return unwrapResultIterator(skillEfficacyQueryInsights(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * upsertSettings skillEfficacy
   *
   * @remarks
   * Create or replace organization-wide skill efficacy sampling settings.
   */
  async upsertSettings(
    request: UpsertSkillEfficacySettingsRequest,
    security?: UpsertSkillEfficacySettingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SkillEfficacySettings> {
    return unwrapAsync(skillEfficacyUpsertSettings(
      this,
      request,
      security,
      options,
    ));
  }
}
